var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nd-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('fechar');
      }
    }
  }, [_c('div', {
    staticClass: "nd-modal"
  }, [_c('div', {
    staticClass: "nd-modal__header"
  }, [_c('div', [_c('h4', {
    staticClass: "nd-modal__title"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice mr-2"
  }), _vm._v(" NFC-e #" + _vm._s(_vm.nfceDetalhe.numero || _vm.nfceDetalhe.numeroNota || '—') + " / Série " + _vm._s(_vm.nfceDetalhe.serie || '—') + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.nfceDetalhe.uuid_venda_terminal))])]), _c('button', {
    staticClass: "nd-btn nd-btn--light",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "nd-tabs"
  }, [_c('button', {
    class: ['nd-tab', {
      'nd-tab--active': _vm.abaAtiva === 'resumo'
    }],
    on: {
      "click": function click($event) {
        _vm.abaAtiva = 'resumo';
      }
    }
  }, [_vm._v("Resumo")]), _c('button', {
    class: ['nd-tab', {
      'nd-tab--active': _vm.abaAtiva === 'itens'
    }],
    on: {
      "click": function click($event) {
        _vm.abaAtiva = 'itens';
      }
    }
  }, [_vm._v("Itens")])]), _c('div', {
    staticClass: "nd-modal__body"
  }, [_vm.abaAtiva === 'resumo' ? [_c('div', {
    class: ['nd-status-box', _vm.statusClass]
  }, [_c('i', {
    staticClass: "mr-2",
    class: _vm.statusIcon
  }), _c('strong', [_vm._v(_vm._s(_vm.statusLabel))]), _c('span', {
    staticClass: "ml-2 nd-tipo-emissao"
  }, [_vm._v(_vm._s(_vm.tipoEmissaoLabel))])]), _c('table', {
    staticClass: "nd-info-table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Número")]), _c('td', [_vm._v(_vm._s(_vm.nfceDetalhe.numero || _vm.nfceDetalhe.numeroNota || '—'))])]), _c('tr', [_c('th', [_vm._v("Série")]), _c('td', [_vm._v(_vm._s(_vm.nfceDetalhe.serie || '—'))])]), _c('tr', [_c('th', [_vm._v("Emissão")]), _c('td', [_vm._v(_vm._s(_vm._f("dataHora")(_vm.nfceDetalhe.emissao || _vm.nfceDetalhe.dtVenda || _vm.nfceDetalhe.created_at)))])]), _c('tr', [_c('th', [_vm._v("Cliente")]), _c('td', [_vm._v(_vm._s(_vm.nfceDetalhe.nomeCliente || 'Consumidor final'))])]), _c('tr', [_c('th', [_vm._v("Valor total")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("brl")(_vm.nfceDetalhe.valorTotal)))])])]), _c('tr', [_c('th', [_vm._v("Status")]), _c('td', [_vm._v(_vm._s(_vm.statusLabel))])]), _c('tr', [_c('th', [_vm._v("Tipo emissão")]), _c('td', [_vm._v(_vm._s(_vm.tipoEmissaoLabel))])]), _vm.nfceDetalhe.protocolo ? _c('tr', [_c('th', [_vm._v("Protocolo")]), _c('td', {
    staticClass: "font-mono"
  }, [_vm._v(_vm._s(_vm.nfceDetalhe.protocolo))])]) : _vm._e()])]), _vm.nfceDetalhe.chave ? _c('div', {
    staticClass: "nd-chave-box"
  }, [_c('div', {
    staticClass: "nd-chave-label"
  }, [_vm._v("Chave de acesso")]), _c('div', {
    staticClass: "nd-chave-valor font-mono"
  }, [_vm._v(_vm._s(_vm.fmtChave(_vm.nfceDetalhe.chave)))]), _c('button', {
    staticClass: "nd-btn nd-btn--outline nd-btn--sm mt-2",
    on: {
      "click": function click($event) {
        return _vm.copiar(_vm.nfceDetalhe.chave, 'chave');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-copy mr-1"
  }), _vm._v(_vm._s(_vm.copiado === 'chave' ? 'Copiado!' : 'Copiar chave') + " ")])]) : _vm._e(), _c('div', {
    staticClass: "nd-secao"
  }, [_c('h5', {
    staticClass: "nd-secao__title"
  }, [_vm._v("Formas de pagamento")]), _vm.pagamentos.length ? _c('table', {
    staticClass: "nd-table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.pagamentos, function (p, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(p.descricao || '—'))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(p.parcelas || 1))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("brl")(p.valor)))])]);
  }), 0)]) : _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("Sem pagamentos registrados.")])]), _vm.nfceDetalhe.motivo_erro || _vm.nfceDetalhe.ultimo_erro ? _c('div', {
    staticClass: "nd-alert nd-alert--danger mt-3"
  }, [_c('strong', [_vm._v("Motivo:")]), _vm._v(" " + _vm._s(_vm.nfceDetalhe.motivo_erro || _vm.nfceDetalhe.ultimo_erro) + " "), _vm.nfceDetalhe.codigo_rejeicao ? _c('span', [_vm._v(" (#" + _vm._s(_vm.nfceDetalhe.codigo_rejeicao) + ")")]) : _vm._e()]) : _vm._e()] : _vm._e(), _vm.abaAtiva === 'itens' ? [_vm.carregandoItens ? _c('div', {
    staticClass: "text-center py-4 text-muted"
  }, [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }), _vm._v("Carregando... ")]) : _c('table', {
    staticClass: "nd-table"
  }, [_vm._m(1), _c('tbody', [_vm.itens.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Nenhum item.")])]) : _vm._e(), _vm._l(_vm.itens, function (item, i) {
    return [_c('tr', {
      key: "item-".concat(item.id)
    }, [_c('td', [_vm._v(_vm._s(i + 1))]), _c('td', [_vm._v(_vm._s(item.descricao))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatQtd(item.quantidade)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("brl")(item.valor_unitario)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("brl")(item.desconto)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("brl")(item.acrescimo)))]), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("brl")(item.total)))])])]), _vm.itemExtras(item).length ? _c('tr', {
      key: "extras-".concat(item.id),
      staticClass: "nd-item-extras"
    }, [_c('td'), _c('td', {
      attrs: {
        "colspan": "6"
      }
    }, _vm._l(_vm.itemExtras(item), function (ex, ix) {
      return _c('span', {
        key: ix,
        staticClass: "nd-tag"
      }, [_vm._v(_vm._s(ex))]);
    }), 0)]) : _vm._e()];
  })], 2)])] : _vm._e()], 2), _c('div', {
    staticClass: "nd-modal__footer"
  }, [_c('button', {
    staticClass: "nd-btn nd-btn--secondary",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v("Fechar")])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Forma")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Parcelas")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Qtd")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Unit.")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Desc.")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Acrésc.")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")])])]);
}];
export { render, staticRenderFns };